import React from "react";
import {APIProvider} from '@vis.gl/react-google-maps';
import {StoreLocatorProvider} from "./context/store-locator";
import DealerMap from "./components/map";
import Search from "./components/search";
import SearchResult from "./components/search-result";
import Loading from "./components/loading";
import DealerDetail from "./components/dealer-detail";
import Sidebar from "./components/sidebar";

const App = () => {
    const apiKey = (window as any).rz_store_locator.google_api_key;
    return (
        <APIProvider apiKey={apiKey} onLoad={() => console.log('Maps API has loaded.')}>
            <StoreLocatorProvider>
                <>
                    <DealerMap/>
                    <Sidebar />
                    <Loading />
                </>

            </StoreLocatorProvider>
        </APIProvider>
    )
}
export default App;
